angular.module('unica_invitation.invitation_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// INVITATION
		.state('app.invitation', {
			url: '/invitation',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/invitation/templates/invitation.html',
					controller: 'InvitationBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// INVITATIONS LIST
			.state('app.invitation.list', {
				url: '/list/:event_id/:invitation_list_id',
				views: {
					'invitationContent': {
						templateUrl: './modules/invitation/templates/list.html',
						controller: 'InvitationListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: '{{ invitationListData.name }}',
					parent: function($scope) {
						return 'app.invitation_list.list({event_id:' + $scope.event_id + '})';
					}
				}
			})

			// INVITATION EDIT
			.state('app.invitation.edit', {
				url: '/edit/:event_id/:invitation_list_id/:id',
				views: {
					'invitationContent': {
						templateUrl: './modules/invitation/templates/edit.html',
						controller: 'InvitationEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Invito #{{ invitationData.id }}',
					parent: function($scope) {
						return 'app.invitation.list({event_id:' + $scope.event_id + ', invitation_list_id: '+ $scope.invitation_list_id +'})';
					}
				}
			})

			// INVITATION TAGS
			.state('app.invitation.tags', {
				url: '/tags/:event_id/:invitation_list_id/:id',
				views: {
					'invitationContent': {
						templateUrl: './modules/invitation/templates/tags.html',
						controller: 'InvitationTagsController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'TAGS Invito #{{ invitationData.id }}',
					parent: function($scope) {
						return 'app.invitation.list({event_id:' + $scope.event_id + ', invitation_list_id: '+ $scope.invitation_list_id +'})';
					}
				}
			})


			// INVITATION SEARCH
			.state('app.invitation.search', {
				url: '/search/:event_id',
				views: {
					'invitationContent': {
						templateUrl: './modules/invitation/templates/search.html',
						controller: 'InvitationSearchController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Ricerca Invito',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			});


});

